export const NotFoundPage = ():JSX.Element => {
  return <div className="container">
    <div className="row">
    <div className="large-text-1 fw-bold my-5 text-center">404 - Page Not Found</div>
    </div>
  </div>
}

